import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that re-renders product details when the selected variant changes.
 *
 * @extends Component
 */
export class ProductDetails extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#handleVariantUpdate), {
      signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  /**
   * Replaces the current product details with the updated markup from the variant response.
   *
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;

    const newProductDetails = source.querySelector('product-details');

    if (!newProductDetails) return;

    if (!event.detail.data.newProduct) {
      const currentVariantContentBlocks = this.querySelectorAll('[data-variant-content-block-id]');

      if (currentVariantContentBlocks.length) {
        currentVariantContentBlocks.forEach((currentBlock) => {
          if (!(currentBlock instanceof HTMLElement)) return;

          const blockId = currentBlock.dataset.variantContentBlockId;
          if (!blockId) return;

          const nextBlock = newProductDetails.querySelector(`[data-variant-content-block-id="${blockId}"]`);
          if (!(nextBlock instanceof HTMLElement)) {
            currentBlock.innerHTML = '';
            return;
          }

          currentBlock.innerHTML = nextBlock.innerHTML;
        });

        return;
      }
    }

    this.replaceWith(newProductDetails);
  };
}

if (!customElements.get('product-details')) {
  customElements.define('product-details', ProductDetails);
}
